import React, { useState } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import AutoSuggest from 'react-autosuggest'
import FuzzySearch from 'fuzzy-search'

const Input = styled.input`
  background-color: ${colors.background600};
  border: 1px solid ${colors.borderColor};
  padding: 8px 16px;
  outline: none;
`
const AutoSuggestStyled = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  input {
    box-sizing: border-box;
    background-color: ${colors.background600};
    color: ${colors.text};
    border: 1px solid ${colors.borderColor};
    outline: none;
    padding: 8px 16px;
    width: 100%;
  }

  > div > div:empty {
    display: none;
  }

  > div > div {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: #fff;
    z-index: 50;
    border: 1px solid ${colors.borderColor};
    border-top: none;

    > ul {
      overflow-y: auto;
      max-height: 400px;
      background: ${colors.background600};
    }

    > ul > li {
      cursor: pointer;
      padding: 12px 16px;

      &:hover {
        background: ${colors.background800};
      }
    }
  }
`

const AutoComplete = ({
  suggestions,
  value,
  placeholder,
  onChange,
  onBlur,
  ...props
}) => {
  const [activeSuggestions, setActiveSuggestions] = useState([])
  const searcher = new FuzzySearch(suggestions, [])
  return (
    <AutoSuggestStyled>
      <AutoSuggest
        suggestions={activeSuggestions}
        renderSuggestion={suggestion => (
          <div onClick={() => onChange(suggestion)}>{suggestion}</div>
        )}
        inputProps={{
          value,
          onChange: (e, { newValue }) =>
            typeof onChange === 'function' && onChange(newValue),
          onBlur: (e, { newValue }) =>
            typeof onBlur === 'function' && onBlur(newValue),
          placeholder,
          ...props
        }}
        shouldRenderSuggestions={value => suggestions.indexOf(value) === -1}
        getSuggestionValue={val => val}
        onSuggestionsClearRequested={() => setActiveSuggestions([])}
        onSuggestionsFetchRequested={({ value }) =>
          setActiveSuggestions(
            searcher
              .search(value)
              .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
          )
        }
      />
    </AutoSuggestStyled>
  )
}

export { Input, AutoComplete }
